import type { ItemPrice } from '@app/types/price';

/**
 * Returns discounted price amount if discount is applicable.
 */
export const getItemValue = (price: ItemPrice): number => {
  if (price.discount && price.discount.percent > 0)
    return price.discount.amount;

  return price.amount;
};
